import React, { memo } from 'react'
import { Handle, Position } from '@xyflow/react'

const ConditionGroupNode = memo(({ data, selected }) => {
    const conditions = data.conditions || []
    const condCount = conditions.length

    return (
        <div className={`wf-node wf-node-condition ${selected ? 'wf-node-selected' : ''}`}>
            <div className="wf-node-header wf-node-header-condition">
                <i className="fa fa-filter" /> Conditions
                <span className="wf-node-badge">{data.logicalOperator}</span>
            </div>
            <div className="wf-node-body">
                {condCount > 0 ? (
                    <div className="wf-node-list">
                        {conditions.slice(0, 3).map((c, i) => (
                            <div key={c.id || i} className="wf-node-list-item">
                                <span className="wf-cond-field">{c.fieldName?.replaceAll('_', ' ')}</span>
                                {' '}
                                <span className="wf-cond-op">{c.conditionType?.replaceAll('_', ' ').toLowerCase()}</span>
                                {' '}
                                <span className="wf-cond-val">{c.conditionValue}</span>
                            </div>
                        ))}
                        {condCount > 3 && (
                            <div className="wf-node-more">+{condCount - 3} more</div>
                        )}
                    </div>
                ) : (
                    <div className="wf-node-placeholder">Click to add conditions</div>
                )}
            </div>
            <Handle type="target" position={Position.Top} className="wf-handle" />
            <Handle type="source" position={Position.Bottom} className="wf-handle" />
        </div>
    )
})

ConditionGroupNode.displayName = 'ConditionGroupNode'
export default ConditionGroupNode
